<template>
  <div class="p-exquisite-content-wrap" v-if="dataList.length > 0" v-loading="isLoading">
    <!-- <div class="p-exquisite-content_title">
      <div class="p-exquisite-content_title_left">
        <em class="ibass ibass-speaker blingbling"></em>
        精选内容
      </div>
    </div> -->

    <div class="p-exquisite-content_img" v-if="!!bannerUrl">
      <!-- <a @click="openDetail">
        <img :src="bannerUrl" alt="精选图片">
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      </a> -->
      <!-- <div class="swiper">
        <div class="swiper-wrapper">
          <div v-for="item in swiperList" :key="item.id" class="swiper-slide"><img :src="item.pictureUrl" alt="精选图片"></div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"><i class="ibass ibass-arrow-left"></i></div>
        <div class="swiper-button-next" slot="button-next"><i class="ibass ibass-arrow-right"></i></div>
      </div> -->
      <swiper :options="swiperOption" ref="mySwiper" @click="swiperCLick">
        <swiper-slide v-for="item in swiperList" :key="item.id" :data-name="item.title">
          <img v-if="item.summary == 1" class="new-tip" src="../../../../assets/new.svg" />
           <template v-if="item.title === 'AlphaGPT' && item.url === ''">
            <img @click="toAlphaGPT()" style="cursor: pointer;" :src="item.pictureUrl" :alt="item.title">
          </template>
          <template v-else>
            <a :href="item.url" target="_blank">
              <img :src="item.pictureUrl" :alt="item.title">
            </a>
          </template>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"><i class="ibass ibass-arrow-left"></i></div>
        <div class="swiper-button-next" slot="button-next"><i class="ibass ibass-arrow-right"></i></div>
      </swiper>
    </div>

    <div class="p-exquisite-content_content">
      <ul>
        <li v-for="(item, index) in dataList" :key="index">
          <div>
            <p class="two-ellipsis">
              <span v-if="item.isNew" class="new"></span>
              <a :href="item.url" target="_blank" :title="item.title" @click="addAnalysis(item)">{{item.title}}</a>
            </p>
            <p class="name ellipsis" :title="item.author">{{item.author}}</p>
<!--            <p>{{item.upDateTime}}</p>-->
          </div>
          <a :href="item.url" target="_blank" @click="addAnalysis(item)">
            <img :src="item.pictureUrl" alt="">
          </a>
        </li>
      </ul>
    </div>

    <div class="p-exquisite-content_pagination">
      <el-pagination
        small
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :hide-on-single-page="isSinglePage"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import indexService from '../../service/index'
import utils from '@/utils/time'
export default {
  name: 'PExquisiteContent',
  props: {},
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      isLoading: false,
      dataList: [],
      isSinglePage: false, // 是否单页
      bannerUrl: '',
      bannerLink: '',
      swiperList: [],
      swiperOption: {
        loop: true,
        // direction: 'vertical',
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        slidesPerView: 'auto',
        // loopedSlides: 3,
        // 分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            var customPaginationHtml = ''
            for (var i = 0; i < total; i++) {
              // 判断哪个分页器此刻应该被激活
              if (i === current - 1) {
                customPaginationHtml +=
                  '<span class="swiper-pagination-customs swiper-pagination-customs-active" data-value="' + i + '" onclick="bannerClick(' + i + ')"></span>'
              } else {
                customPaginationHtml +=
                  '<span class="swiper-pagination-customs" onclick="bannerClick(' + i + ')"></span>'
              }
            }
            return '<span class="swiperPag">' + customPaginationHtml + '</span>'
          }
        },

        // 前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next', // 前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', // 后退按钮的css选择器或HTML元素。
          hideOnClick: true // 点击slide时显示/隐藏按钮
        }
      },
      total: 0, // 总条数
      pageIndex: 1,
      pageSize: 4
    }
  },
  mounted () {
    // 获取精品内容列表
    this.getExquiteContentList()
    // 获取精品内容banner
    this.getExquiteContentBanner()
    window.bannerClick = this.bannerClick
  },
  methods: {
    toAlphaGPT() {
      // 使用 Vue Router 生成 URL
      const url = this.$router.resolve({
        path: '/AlphaGPT/index',
        query: {
          token: localStorage.getItem('token')
        }
      }).href;
      // 确定目标 origin
      let origin = location.origin.replace(/(\w+)?\.?alphalawyer.cn/, '$1gpt.alphalawyer.cn');
      if (location.hostname === 'localhost') {
        origin = `http://localhost:${location.port === '4001' ? '4002' : '4001'}`;
      }

      // 打开新窗口
      window.open(origin + url, "_blank");
    },
    async getExquiteContentList () {
      this.isLoading = true
      let response = null
      let type = 'HOME_LIST'
      response = await indexService.getExquisiteContent(type, this.pageIndex, 4)
      if (response.succeed || response.isSuccess) {
        this.isLoading = false
        this.total = response.data.count
        response.data.data.map(item => {
          item.upDateTime = utils.formatTime(new Date(item.publishDate), 'standardTime')
        })
        this.dataList = response.data.data.map(item => {
          item.isNew = (Date.now() - item.publishDate) <= 1000 * 60 * 60 * 24 * 7
          return item
        }) || []
      } else {
        this.isLoading = false
        this.$postMessage.toast({ msg: response.message || response.resultMsg })
      }
    },
    async getExquiteContentBanner () {
      this.isLoading = true
      let response = null
      let type = 'HOME_NAVIGATION'
      response = await indexService.getExquisiteContent(type, 1, 6)
      if (response.succeed || response.isSuccess) {
        this.isLoading = false
        this.bannerUrl = response.data.data.length > 0 ? response.data.data[0].pictureUrl : ''
        this.bannerLink = response.data.data.length > 0 ? response.data.data[0].url : ''
        this.swiperList = response.data.data.length > 0 ? response.data.data : []
        var domain = ""
          var hostName = location.hostname;
          switch (hostName) {
            case 'alphalawyer.cn':
              domain = '';
              break;
            case 'dev.alphalawyer.cn':
              domain = 'dev';
              break;
            case 'test.alphalawyer.cn':
              domain = 'test';
              break;
            default:
              domain = '';
              break;
          }
        const GPTRes = await indexService.getIsGPTUser({
          officeId: window.localStorage.officeid,
          userId:  window.localStorage.userid,
        })
        if (GPTRes.isSuccess) {
          let { data } = GPTRes
          this.swiperList.forEach(item => {
            if (item.title === 'AlphaGPT') {
              if (data.opened) {
                item.url = ''
                // if (domain === 'dev') {
                //   item.url = 'https://devgpt.alphalawyer.cn/#/AlphaGPT/index?appId=LAW_SEARCH_COLUMN&tab=BUSINESS_EFFECT'
                // } else if (domain === 'test') {
                //   item.url = 'https://testgpt.alphalawyer.cn/#/AlphaGPT/index?appId=LAW_SEARCH_COLUMN&tab=BUSINESS_EFFECT'
                // } else {
                //   item.url = 'https://gpt.alphalawyer.cn/#/AlphaGPT/index?appId=LAW_SEARCH_COLUMN&tab=BUSINESS_EFFECT'
                // }
              } else {
                if (domain === 'dev') {
                  item.url = 'https://devgpt.alphalawyer.cn/#/AlphaGPT/index?appId=CHAT_GPT&tab=YE_WU&trialId=806b9addf51f47e29701c372f4ffef54'
                } else if (domain === 'test') {
                  item.url = 'https://testgpt.alphalawyer.cn/#/AlphaGPT/index?appId=LAW_SEARCH_COLUMN&tab=BUSINESS_EFFECT&trialId=8179f7a08b58400e910eef7ef32cc567'
                } else {
                  item.url = 'https://gpt.alphalawyer.cn/#/AlphaGPT/index?appId=LAW_SEARCH_COLUMN&tab=BUSINESS_EFFECT&trialId=5bd2efc1735f4fa18a416588ef481260'
                }
              }
            }
          })
        }
        // this.initSwiper()
      } else {
        this.isLoading = false
        this.$postMessage.toast({ msg: response.message || response.resultMsg })
      }
    },
    handleCurrentChange (val) {
      this.pageIndex = val
      this.getExquiteContentList()
      this.$analysis.customeTrack({
        elementName: '工作台_精选内容',
        elementContent: '工作台_精选内容_页码'
      })
    },
    swiperCLick (swiper, event) {
      this.$analysis.track('bd_工作台点击_banner_' + swiper.target.alt)
    },
    addAnalysis (item) {
      this.$analysis.customeTrack({
        elementName: '工作台_精选内容',
        elementContent: '工作台_精选内容_' + item.title
      })
    },
    bannerClick (e) {
      this.$refs.mySwiper.$swiper.slideTo(e, 1000, false)
    }
  }
}
</script>
<style lang="stylus" scoped>
.p-exquisite-content-wrap
  width 100%
  margin 0 auto
  padding 24px 24px 16px
  box-sizing border-box
  overflow auto
  .p-exquisite-content_title
    display flex
    justify-content space-between
    align-items center
    line-height 1
    margin-bottom 16px
    font-size 14px
    .p-exquisite-content_title_left
      display flex
      justify-content space-between
      align-items center
      color #ED6C00
      font-size 14px
      em
        margin-right 12px
      .blingbling
        -webkit-animation scaleout 2s infinite ease-in-out
        animation scaleout 2s infinite ease-in-out
      @-webkit-keyframes scaleout
        0%
          transform scale(1.0)
          -webkit-transform scale(1.0)
        50%
          transform scale(1.1)
          -webkit-transform scale(1.1)
          opacity: .2
        100%
          transform scale(1)
          -webkit-transform scale(1)
          opacity: 1
      @keyframes scaleout
        0%
          transform scale(1.0)
          -webkit-transform scale(1.0)
        50%
          transform scale(1.1)
          -webkit-transform scale(1.1)
          opacity .2
        100%
          transform scale(1)
          -webkit-transform scale(1)
          opacity 1
    .p-exquisite-content_title_more
      cursor pointer
      &:hover
        color #ED6C00
  .p-exquisite-content_img
    width 100%
    height 130px
    border-radius 10px
    margin-bottom: 12px
    .swiper-button-prev,.swiper-button-next
      display: none
      width: 30px
      height: 30px
      cursor: pointer;
      border-radius: 50%;
      &:hover
        background: rgba(51, 51, 51, 0.1);
      &:after
        content: ''
      .ibass-arrow-left,.ibass-arrow-right
        color:#fff
        position: absolute
        top:57%
        left:50%
        transform: translate(-50%,-50%)
        z-index:15
        cursor: pointer
    .swiper-button-prev
        left:12px
    .swiper-button-next
        right:12px
    &:hover
      .swiper-button-prev,.swiper-button-next
        display: block
  .p-exquisite-content_content
    margin-bottom: 10px
    ul
      /*max-height 218px*/
      &::-webkit-scrollbar
        display none
      li
        height 72px
        display flex
        justify-content space-between
        align-items center
        &:not(:last-of-type) {
          margin-bottom: 10px
        }
        a
          img
            width 72px
            height 72px
            border-radius 3px
        div
          p
            max-width 152px
            font-size 12px
            color #8590A6
          p:first-child
            font-size 14px
            a
              color #000
              text-decoration none
              &:hover
                color #ED6C00
          p.name
            width 152px
            padding-top 6px
          p.two-ellipsis
            overflow hidden
            text-overflow ellipsis
            display -webkit-box
            -webkit-line-clamp 2
            line-clamp 2
            -webkit-box-orient vertical
            .new
              position relative
              display inline-block
              width 28px
              height 12px
              &:after
                content 'NEW'
                position absolute
                top -6px
                left -13px
                background-color #f00
                padding 0 4px
                height 24px
                line-height 24px
                color #fff
                border-radius 4px
                font-size 20px
                transform scale(0.5)
  .p-exquisite-content_pagination
    text-align center
.ellipsis
  white-space nowrap
  text-overflow ellipsis
  overflow hidden
.swiper-slide
  overflow hidden
  img
    width: 100%
    border-radius 10px
    cursor: pointer;
  .new-tip
    position: absolute
    top: -4px
    left: -4px
    width: 80px
    height: 80px
</style>
<style lang="stylus">
.swiper-pagination-custom
  bottom:8px;
  left:0;
  width:100%;
  &:hover
    cursor: pointer;
.swiper-pagination-customs
  width:20px
  height:4px
  display:inline-block
  background:#999
  opacity:.5
  margin:0 2px
.swiper-pagination-customs-active
  opacity:1
  background-color:#ed6c00
</style>
